var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useMemo, useState } from 'react';
import { throttle } from 'lodash';
export var MediaDevices;
(function (MediaDevices) {
    MediaDevices["mobile"] = "mobile";
    MediaDevices["tablet"] = "tablet";
    MediaDevices["laptop"] = "laptop";
    MediaDevices["desktop"] = "desktop";
})(MediaDevices || (MediaDevices = {}));
export var useMedia = function () {
    var _a = __read(useState(window.innerWidth), 2), windowWidth = _a[0], setWindowWidth = _a[1];
    var mediaBreakPoints = useMemo(function () {
        return Object.values(MediaDevices).reduce(function (acc, device) {
            var _a;
            var deviceVariable = "--min-" + device + "-width";
            var cssVariable = getComputedStyle(document.documentElement).getPropertyValue(deviceVariable);
            var size = Number(cssVariable.replace(/[^\d]/g, ''));
            return __assign(__assign({}, acc), (_a = {}, _a[device] = size, _a));
        }, {});
    }, []);
    var getMedia = useCallback(function (windowWidth) {
        if (windowWidth === void 0) { windowWidth = window.innerWidth; }
        return ({
            windowWidth: windowWidth,
            isMobile: windowWidth >= mediaBreakPoints.mobile && windowWidth < mediaBreakPoints.tablet,
            isTablet: windowWidth >= mediaBreakPoints.tablet && windowWidth < mediaBreakPoints.laptop,
            isLaptop: windowWidth >= mediaBreakPoints.laptop && windowWidth < mediaBreakPoints.desktop,
            isDesktop: windowWidth >= mediaBreakPoints.desktop,
        });
    }, [mediaBreakPoints]);
    useEffect(function () {
        var handleWindowResize = throttle(function () { return setWindowWidth(window.innerWidth); }, 300);
        window.addEventListener('resize', handleWindowResize);
        return function () { return window.removeEventListener('resize', handleWindowResize); };
    }, []);
    return useMemo(function () { return getMedia(windowWidth); }, [getMedia, windowWidth]);
};
//# sourceMappingURL=mediaQueries.js.map